import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface PaymentHistorySuccessIconProps {
  width?: number;
  height?: number;
}

const PaymentHistorySuccessIcon: React.FC<PaymentHistorySuccessIconProps> = ({
  width = 20,
  height = 20
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.58 8.004l-3.807 5a.833.833 0 01-.658.33H9.11a.835.835 0 01-.655-.32l-2.027-2.59a.833.833 0 111.312-1.026L9.1 11.136l3.154-4.14a.834.834 0 011.325 1.008zM10 1.667a8.333 8.333 0 100 16.666 8.333 8.333 0 000-16.666z"
        fill="#27AB83"
      />
    </svg>
  </SVGUniqueID>
);

export { PaymentHistorySuccessIcon };
